<template>
  <div class="login-forgot-pass-form">
    <div class="page-description">
      {{ (!mailSent ? 'login_password_recovery' : 'general_email_sent_success') | translate }}
      {{ siteTitle }}
    </div>
    <div class="page-info login-row-space">
      {{ (!mailSent ? 'login_password_forgotten' : 'login_password_recevered_info') | translate }}
    </div>
    <MdtMessage
      v-if="validationMsg.body"
      :title="validationMsg.title"
      :body="validationMsg.body"
      type="danger"
      class="validation-msg" />
    <div class="login-content">
      <div
        v-if="!mailSent"
        class="input-wrapper">
        <MdtInput
          ref="email"
          v-model="email"
          :type="'email'"
          :label="'general_email_address' | translate"
          :required="true"
          @keyupEnter="resetPassword" />
      </div>
      <div
        class="login-content-link pointer"
        @click="$emit('login')">
        {{ 'login_sign_in' | translate }}
      </div>
    </div>
    <div
      v-if="!mailSent"
      class="footer-buttons">
      <div
        class="btn btn-primary"
        @click="resetPassword">
        {{ 'login_password_reset' | translate }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginForgotPassForm',
  data() {
    return {
      email: '',
      mailSent: false,
      validationMsg: {
        title: '',
        body: '',
      },
      loading: false,
    };
  },
  computed: {
    siteTitle() {
      return this.$store.state.publicPage.siteTitle;
    },
  },
  methods: {
    resetPassword() {
      if (this.loading || !this.$refs.email.isValid()) return;

      this.resetValidationMsg();

      const params = {
        email: this.email,
      };

      this.loading = true;
      this.$store.dispatch('auth/resetPassword', params).then(() => {
        this.mailSent = true;
      }).catch((err) => {
        this.validationMsg.title = err?.response?.data?.title || '';
        this.validationMsg.body = err?.response?.data?.description || '';
      }).finally(() => {
        this.loading = false;
      });
    },
    resetValidationMsg() {
      this.validationMsg.title = '';
      this.validationMsg.body = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.input-wrapper {
  .mdt-input {
    margin-bottom: 24px;

    &:last-child .mdt-input {
      margin-bottom: 0;
    }
  }
}
</style>
